// @ts-ignore
import * as aes256 from "aes256";
import Authentication from "../../../domain/authentication/Authentication";
import AutoLogin from "../../../domain/authentication/AutoLogin";
import LoginId from "../../../domain/authentication/LoginId";
import LoginPassword from "../../../domain/authentication/LoginPassword";
import StorageRepository from "../../../domain/fundamentals/storage/StorageRepository";
import LocalStorageDataSource from "../../../infrastructure/datasource/storage/LocalStorageDataSource";

export default class GetAuthentication {
  private static ENCRYPT_ID_KEY: string = "auto_login_id";
  private static ENCRYPT_PASSWORD_KEY: string = "auto_login_password";
  private static STORAGE_KEY: string = "autoLoginData";

  constructor(private readonly repository: StorageRepository = new LocalStorageDataSource()) {
  }

  public execute(): Authentication {
    const item: string = this.repository.findBy(GetAuthentication.STORAGE_KEY);
    if (item === "") {
      return Authentication.empty();
    }

    const loginData = JSON.parse(item);
    const id: string = aes256.decrypt(GetAuthentication.ENCRYPT_ID_KEY, loginData.id);
    const password: string = aes256.decrypt(GetAuthentication.ENCRYPT_PASSWORD_KEY, loginData.password);
    return Authentication.of(
      LoginId.of(id),
      LoginPassword.of(password),
      AutoLogin.of(true)
    );
  }
}